module.exports = __webpack_public_path__ + "static/media/BG_68.3c3bb16a.png";